var map = {
	"./20.svg": 3392,
	"./21.svg": 4070,
	"./22.svg": 3096,
	"./23.svg": 1509,
	"./24.svg": 6443,
	"./25.svg": 7218,
	"./26.svg": 3334,
	"./27.svg": 9730,
	"./28.svg": 8030,
	"./30.svg": 6536,
	"./31.svg": 3052,
	"./32.svg": 330,
	"./33.svg": 5143,
	"./34.svg": 5345,
	"./36.svg": 6902,
	"./37.svg": 1684,
	"./38.svg": 1722,
	"./39.svg": 1757,
	"./74.svg": 5834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9779;